export class RestoreBucketRequest {
    'destination';
    'restoreAccountId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "destination",
            "baseName": "destination",
            "type": "ObjectStorageDestination",
            "format": ""
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreBucketRequest.attributeTypeMap;
    }
    constructor() {
    }
}
